export default (state = [], action) => {
	switch (action.type) {
		case "ADD_ACTIVE_LANGUAGE":
			var newState = state.slice();
			newState.push(action.language);
			return newState;
		default:
			return state;
	}
};
